var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudUploading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cloud-uploading",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.662,
    height: 15.762,
    viewBox: "0 0 21.662 15.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9840",
    "data-name": "Group 9840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37623",
    "data-name": "Path 37623",
    d: "M16.926,82.412H12.278v-4.7h1.536a.48.48,0,0,0,.39-.761L11.216,72.82a.476.476,0,0,0-.775,0L7.454,76.954a.479.479,0,0,0,.39.761H9.379v4.7H4.174A4.655,4.655,0,0,1,0,77.756a4.409,4.409,0,0,1,2.187-3.807,2.956,2.956,0,0,1-.181-1.031,3,3,0,0,1,3-3,2.95,2.95,0,0,1,1.027.181,6.008,6.008,0,0,1,11.415,1.983,5.227,5.227,0,0,1-.522,10.331Z",
    transform: "translate(0 -66.65)",
    fill: "#2179fe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploading);
export default __webpack_public_path__ + "static/media/cloud-uploading.7bf80206.svg";
export { ForwardRef as ReactComponent };